module.exports = __webpack_public_path__ + "83914282230e296c843502d34f457328.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/floor_items/basketball.png
// module id = 971
// module chunks = 0